import React from 'react';
import { Stack, Typography } from '@mui/material';

import { payerNumber } from '../../utils/personRef';

interface Props {
  payer: { name: string; grNumber?: string | null; applicationNumber?: string | null };
  rollNumber?: number | null;
}

/**
 * Who a challan or payment belongs to: name, then the number they're known
 * by — GR once enrolled, the application number before — and their roll.
 */
const PayerCell: React.FC<Props> = ({ payer, rollNumber }) => {
  const number = payerNumber(payer);
  return (
    <>
      <Typography variant="body2" fontWeight={600}>{payer.name}</Typography>
      <Stack direction="row" spacing={0.75} alignItems="baseline">
        {number && (
          <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'text.disabled' }}>
            {number}
          </Typography>
        )}
        {rollNumber != null && (
          <Typography variant="caption" color="text.secondary">
            {number ? '· ' : ''}Roll {rollNumber}
          </Typography>
        )}
      </Stack>
    </>
  );
};

export default PayerCell;
